import PartnerLogo from './PartnerLogo/PartnerLogo';

export default PartnerLogo;
